var map = {
	"./400.svg": "3730",
	"./401.svg": "4a78",
	"./402.svg": "0a11",
	"./403.svg": "1576",
	"./404.svg": "8e71",
	"./405.svg": "b01b",
	"./500.svg": "20eb",
	"./502.svg": "f46a",
	"./icons/browser.svg": "0fc9",
	"./icons/file.svg": "890d",
	"./mountains.svg": "c092"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0591";